export default "__VITE_ASSET__DrV3wy0O__"